exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consignment-link[data-v-567acf77]:hover{color:#16a8e2}.t-bg-red[data-v-567acf77]{background:red;border-color:red}.depot-card-meta[data-v-567acf77]{justify-content:left}", ""]);

// exports
